/**
 * Formatting utilities
 */

/**
 * Format weight value for display
 * Handles the -0.0 case by displaying as 0.0
 * @param weight - The weight value in grams
 * @param showHundredthsUnder10g - If true, show 2 decimal places for weights under 10g
 */
export function formatWeight(weight: number, showHundredthsUnder10g: boolean = false): string {
  const absWeight = Math.abs(weight)
  const decimals = (showHundredthsUnder10g && absWeight < 10) ? 2 : 1
  const formatted = weight.toFixed(decimals)

  // Handle -0.0 and -0.00 cases
  if (formatted === '-0.0' || formatted === '-0.00') {
    return decimals === 2 ? '0.00' : '0.0'
  }
  return formatted
}
